import { render, staticRenderFns } from "./TableCreation.vue?vue&type=template&id=7daaea60&scoped=true"
import script from "./TableCreation.vue?vue&type=script&lang=js"
export * from "./TableCreation.vue?vue&type=script&lang=js"
import style0 from "./TableCreation.vue?vue&type=style&index=0&id=7daaea60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daaea60",
  null
  
)

export default component.exports